import { QueryClient, QueryKey } from "@tanstack/react-query";
import { isNetworkingError } from "services/ApiClient/networkingError";

export function updateQueryClientData<T>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  newData: T,
) {
  queryClient.setQueryData(queryKey, (oldData: T | undefined) => {
    if (!oldData) {
      return newData;
    }
    return { ...oldData, ...newData };
  });
}

export function retry3TimesPolicy(failureCount: number, error: any) {
  if (isNetworkingError(error) && error.status === 404) {
    return failureCount < 1;
  }
  return failureCount < 3;
}
